document.addEventListener("alpine:init", () => {
    Alpine.data("table", () => ({
        showBefore: false,
        showAfter: false,
        init() {
            this.scroll();
        },
        scroll() {
            if (this.$refs.tableWrapper.scrollWidth <= this.$refs.tableWrapper.clientWidth) {
                this.showBefore = false;
                this.showAfter = false;
                return;
            }
            if (this.$refs.tableWrapper.scrollLeft === 0) {
                this.showBefore = false;
            } else {
                this.showBefore = true;
            }
            if (
                this.$refs.tableWrapper.scrollLeft <
                this.$refs.tableWrapper.scrollWidth - this.$refs.tableWrapper.clientWidth
            ) {
                this.showAfter = true;
            } else {
                this.showAfter = false;
            }
        },
    }));
});
